{
  "title": "Visit",
  "backToMyVisits": "Back to my visits",
  "loading": "Loading…",
  "notYourVisit": "Only the visit’s team (or a service manager) can work on this visit.",
  "errors": {
    "changed": "This visit changed meanwhile. The latest is shown: check it and try again.",
    "changedRetry": "This visit changed meanwhile and has been reloaded. Check the details and finish again."
  },
  "toast": {
    "started": "Visit started.",
    "workBegun": "Work started.",
    "workSaved": "Work saved.",
    "finished": "Visit finished.",
    "finishedFollowUp": "Visit finished. Another visit was requested."
  },
  "cancelled": {
    "title": "This visit was cancelled"
  },
  "header": {
    "follows": "follows {{visit}} of {{date}}",
    "openJob": "Open job {{number}}",
    "missed": "Missed",
    "lead": "Lead: {{name}}",
    "officeNotes": "Notes from the office",
    "reschedule": "Reschedule",
    "cancel": "Cancel visit",
    "noLead": "No lead yet"
  },
  "leftFromLast": {
    "title": "Left from the last visit",
    "whyNothing": "Why nothing was done",
    "unresolved": "Still unresolved",
    "managerNote": "Manager’s note"
  },
  "steps": {
    "label": "Visit steps",
    "counter": "Step {{n}} of {{total}}:",
    "arrive": "Arrive",
    "work": "Work",
    "finish": "Finish",
    "allDone": "Visit finished.",
    "state": {
      "done": "done",
      "current": "current step",
      "todo": "to do"
    }
  },
  "location": {
    "title": "Location",
    "more": "Location and contact",
    "noContact": "No contact recorded.",
    "directions": "Directions",
    "directionsLabel": "Directions to {{site}} (opens maps)",
    "call": "Call",
    "callLabel": "Call {{name}}"
  },
  "items": {
    "title": "Items",
    "empty": "No items yet.",
    "emptyInvite": "Add what the job needs: services and parts with their prices.",
    "total": "Total (VAT included)",
    "agreement": "v{{sequence}} · {{method}}",
    "approvalTitle": "The customer needs to approve the price",
    "approvalBody": "Work on items marked “Needs price approval” can’t be recorded until the customer agrees.",
    "approvalAwaiting": "The price was sent to the customer. Record their answer to go on with that work.",
    "add": "Add item",
    "recordAnswer": "Record the customer’s answer",
    "recordApproval": "Record price approval",
    "edit": "Edit {{item}}",
    "agreedIn": "Agreed (v{{sequence}})",
    "noApprovalNeeded": "No approval needed",
    "needsApproval": "Needs price approval",
    "progress": "Done {{done}} of {{quantity}}",
    "emptyClosed": "No items were on this visit."
  },
  "work": {
    "thisVisit": "Done on this visit",
    "inputLabel": "Done on this visit: {{item}}",
    "less": "One less: {{item}}",
    "more": "One more: {{item}}",
    "allDone": "All done",
    "blocked": "Waiting for the customer’s price approval: record it before this work.",
    "leftAfter": "Left after this visit: {{n}}",
    "complete": "Completed.",
    "doneHere": "{{n}} done on this visit",
    "tooMuch": "At most {{max}} on this visit.",
    "belowInvoiced": "At least {{min}}: that much is already invoiced.",
    "fixFirst": "Correct the quantities marked in red first.",
    "save": "Save work"
  },
  "photos": {
    "required": "Your company requires at least one photo before a visit can finish."
  },
  "report": {
    "title": "Visit report",
    "workPerformed": "What was done",
    "more": "More report fields",
    "empty": "Nothing was written in the report.",
    "autosave": "Saved as you go",
    "saving": "Saving…",
    "saved": "Saved",
    "notSaved": "The report was not saved",
    "retry": "Save again"
  },
  "summary": {
    "title": "Visit summary",
    "outcome": "Outcome",
    "note": "Note",
    "arrived": "Arrived",
    "started": "Work began",
    "finished": "Finished"
  },
  "followUp": {
    "title": "Follow-up visit",
    "remains": "Work remains on this job. Ask for a follow-up visit: the service manager approves it and books it.",
    "invite": "Need another visit to finish (parts, more time, no access)? Ask for one.",
    "request": "Request a follow-up visit",
    "returned": "Returned by {{name}}",
    "returnedPlain": "Returned with a note",
    "openVisit": "Open the follow-up visit",
    "resubmit": "Edit and resubmit",
    "requestTitle": "Request a follow-up visit",
    "resubmitTitle": "Edit and resubmit the request",
    "description": "The service manager approves it and books the visit.",
    "dateHint": "When the customer can receive the team (optional).",
    "submit": "Send request",
    "resubmitSubmit": "Resubmit request",
    "chooseReason": "Choose a reason.",
    "remainingRequired": "Say what is left to do.",
    "endBeforeStart": "The end is before the start.",
    "sent": "Follow-up request sent to the service manager.",
    "resent": "Request sent again.",
    "bookedAtOnce": "The visit is booked for your team at once: on the proposed date, else the next working day.",
    "bookSubmit": "Book the visit",
    "booked": "Follow-up visit booked. Open it from this visit.",
    "remainsAtOnce": "Work remains on this job. Book another visit for your team."
  },
  "rest": {
    "title": "The rest of the job",
    "visitDone_one": "The {{n}} asset in this visit is checked.",
    "visitDone_other": "All {{n}} assets in this visit are checked.",
    "visitPart": "{{checked}} of {{total}} assets in this visit are checked.",
    "job": "The job covers {{total}} assets: {{checked}} checked, {{left}} still to check.",
    "where": "Still to check",
    "why": "That is why this visit closed as partly done: the job is complete once every asset is checked.",
    "book": "Book the rest",
    "office": "The office books a visit for the rest of the job."
  },
  "money": {
    "title": "Invoices and payments",
    "contract": "Covered by a service contract: no invoice is raised from this visit.",
    "invoices": "Invoices",
    "noInvoices": "Nothing invoiced yet.",
    "balance": "Balance",
    "collections": "Payments reported",
    "invoice": "Invoice completed work",
    "collect": "Record payment"
  },
  "action": {
    "start": "Start visit",
    "startHint": "Tap when you arrive at the site.",
    "beginWork": "Start work",
    "beginWorkHint": "You’re on site. Start the work to record what you do.",
    "finish": "Finish visit",
    "unsavedWork": "The quantities you changed are saved when you finish.",
    "followUp": "Request a follow-up visit",
    "invoice": "Invoice completed work",
    "collect": "Record payment",
    "nextVisit": "Next visit",
    "nextVisitHint": "Next for your team today: {{customer}} · {{place}}"
  },
  "finish": {
    "title": "Finish {{visit}}",
    "description": "Once finished, the visit stays as it happened.",
    "outcome": "How did it go?",
    "allDone": "All done",
    "comeBack": "Need to come back",
    "couldNot": "Couldn’t do the work",
    "fullHint": "Everything left on the job is marked as done.",
    "fullBlocked": "“{{item}}” still needs the customer’s price approval.",
    "partialHint": "Part of the work is done. The rest needs another visit.",
    "noneHint": "No work was done on this visit.",
    "noneBlocked": "Work is recorded on this visit: choose “Need to come back”.",
    "chooseOutcome": "Choose how the visit went.",
    "why": "Why couldn’t the work be done?",
    "whyRequired": "Say why the work couldn’t be done.",
    "whyPick": "What happened?",
    "whyReason": {
      "CUSTOMER_UNAVAILABLE": "No one at the site",
      "ACCESS_PROBLEM": "Couldn’t get access",
      "PARTS_NEEDED": "Parts or tools needed",
      "OTHER": "Other"
    },
    "whySentence": {
      "CUSTOMER_UNAVAILABLE": "No one was at the site to let us in.",
      "ACCESS_PROBLEM": "We couldn’t get access to the site or the equipment.",
      "PARTS_NEEDED": "Parts or tools were needed that we didn’t have with us."
    },
    "waitingParts": "The job will show as waiting for parts until the next visit starts.",
    "waitingCustomer": "The job will show as waiting for the customer until the next visit starts.",
    "left": "What’s left to do",
    "leftRequired": "Say what is left to do.",
    "askAgain": "Ask for another visit",
    "reason": "Reason for another visit",
    "nextDate": "Preferred date",
    "signOff": "Customer sign-off",
    "optional": "Optional",
    "ackName": "Customer’s name",
    "ackHint": "The customer who saw the work.",
    "ackRequired": "Enter the name of the customer who acknowledged the visit.",
    "photoRequired": "Add at least one photo of the work before finishing.",
    "submit": "Finish visit",
    "leftPlanned_one": "{{n}} asset still to check",
    "leftPlanned_other": "{{n}} assets still to check",
    "leftPlace": "{{place}}: {{assets}}",
    "placeAssets_one": "{{n}} asset",
    "placeAssets_other": "{{n}} assets",
    "fullChecked": "Every asset of the job is checked.",
    "fullChecksLeft_one": "{{n}} asset isn’t checked yet: the job can’t finish in full.",
    "fullChecksLeft_other": "{{n}} assets aren’t checked yet: the job can’t finish in full.",
    "partialChecksLeft_one": "{{n}} asset is left for the next visit.",
    "partialChecksLeft_other": "{{n}} assets are left for the next visit.",
    "checksWaiting_one": "{{n}} check is still waiting to send. Send it (Retry on the checklist) before finishing.",
    "checksWaiting_other": "{{n}} checks are still waiting to send. Send them (Retry on the checklist) before finishing.",
    "checksIncomplete_one": "{{n}} asset of this planned job isn’t checked yet. Check it, or choose “Need to come back”.",
    "checksIncomplete_other": "{{n}} assets of this planned job aren’t checked yet. Check them, or choose “Need to come back”.",
    "checksIncompleteUnknown": "Some assets of this planned job aren’t checked yet. Check them, or choose “Need to come back”.",
    "bookAgain": "Book another visit",
    "markRest_one": "Mark the {{n}} unchecked asset as done and finish",
    "markRest_other": "Mark the {{n}} unchecked assets as done and finish",
    "markRestHint": "Only when every asset was in fact checked: each is recorded as Done by you.",
    "markRestRequired": "Tick it to finish in full, or choose “Need to come back”."
  },
  "invoice": {
    "title": "Invoice completed work",
    "description": "One invoice for {{job}}, posted in Sales.",
    "hint": "Each quantity starts at what is completed and not yet invoiced. Enter 0 to leave an item out.",
    "ready": "Ready to invoice: {{n}}",
    "quantity": "Quantity to invoice: {{item}}",
    "atMost": "At most {{n}}.",
    "total": "Invoice total",
    "posts": "The invoice is posted at once: revenue and VAT go to the books.",
    "submit": "Post invoice",
    "nothing": "Nothing completed is left to invoice.",
    "tooMuch": "Some quantities are more than is ready to invoice.",
    "chooseOne": "Enter a quantity for at least one item.",
    "doneTitle": "Invoice posted",
    "posted": "Posted invoice",
    "already": "Already invoiced as",
    "nextStep": "When the customer pays, record the payment.",
    "open": "Open invoice {{number}}",
    "recordPayment": "Record payment",
    "close": "Done",
    "paidNow": "Did the customer pay now?",
    "paidNowNo": "Not now",
    "paidNowCash": "Cash",
    "paidNowCard": "Card",
    "paidNowHint": "The payment is recorded for the full total, today, and waits for the accountant’s verification.",
    "submitPaid": "Post and record payment",
    "paidToast": "Invoice {{number}} posted and payment recorded",
    "paidFailed": "The invoice is posted, but the payment was not recorded. Record it here."
  },
  "collection": {
    "title": "Record payment",
    "verifyNote": "The invoice balance changes only once the accountant verifies this payment.",
    "loadingInvoice": "Loading the invoice just posted…",
    "invoice": "Invoice",
    "open": "Open:",
    "reported": "Awaiting verification:",
    "amount": "Amount received",
    "method": "Method",
    "collectedOn": "Received on",
    "reference": "Reference",
    "referenceHint": "Cheque number or transfer reference.",
    "notes": "Notes",
    "submit": "Record payment",
    "nothing": "No posted invoice of this job has a balance to collect.",
    "chooseInvoice": "Choose the invoice the customer paid.",
    "amountRequired": "Enter an amount above zero.",
    "tooMuch": "That is more than is open on the invoice ({{open}}).",
    "dateRequired": "Enter the date the money was received.",
    "toast": "Payment recorded against {{number}}",
    "addPhoto": "Add photo",
    "doneTitle": "Payment recorded",
    "recorded": "Recorded against",
    "awaiting": "It is awaiting the accountant’s verification; the invoice balance changes once it is verified.",
    "evidenceHint": "Add a photo of the receipt or the transfer slip.",
    "close": "Done"
  },
  "myVisits": {
    "title": "My visits",
    "intro": "Your teams’ visits for the day.",
    "day": "Day shown",
    "today": "Today",
    "previous": "Previous",
    "next": "Next",
    "previousDay": "Previous day",
    "nextDay": "Next day",
    "emptyToday": "No visits for your teams today.",
    "empty": "No visits for your teams on this day.",
    "emptyHint": "Visits the office books for your teams appear here.",
    "goToday": "Go to today",
    "listLabel": "Visits",
    "missed": "Missed",
    "earlierTitle": "Earlier, still open",
    "earlierFailed": "Visits left open on earlier days could not be loaded.",
    "todayTitle": "Today’s visits",
    "count_one": "{{n}} visit · {{done}} finished",
    "count_other": "{{n}} visits · {{done}} finished",
    "countToday_one": "Today: {{n}} visit · {{done}} finished",
    "countToday_other": "Today: {{n}} visits · {{done}} finished",
    "dayHeading": "{{weekday}}, {{date}}",
    "nextVisit": "Next visit: {{date}}",
    "noneAhead": "No visits for your teams in the next {{n}} days either.",
    "callLabel": "Call {{name}}, {{customer}}"
  },
  "leave": {
    "title": "Discard unsaved changes?",
    "body": "The quantities you changed on this visit are not saved yet.",
    "reportBody": "The latest changes to the visit report could not be saved.",
    "confirm": "Discard changes",
    "stay": "Keep editing"
  },
  "checklist": {
    "title": "Equipment checklist",
    "assets_one": "{{n}} asset in this visit",
    "assets_other": "{{n}} assets in this visit",
    "beforeStart": "Checks are recorded once the visit starts.",
    "readOnly": "The checks recorded on this visit.",
    "empty": "No assets in this view.",
    "announce": "{{tag}}: {{outcome}}",
    "progress": {
      "label": "Checklist progress",
      "visit": "{{checked}} of {{total}} checked",
      "job": "The job: {{checked}} of {{total}} checked on all its visits"
    },
    "saves": {
      "waiting_one": "{{n}} check waiting to send",
      "waiting_other": "{{n}} checks waiting to send",
      "retry": "Retry",
      "sending": "Saving",
      "saved": "Saved",
      "held": "Waiting",
      "notSaved": "Not saved",
      "refused": "Not saved: {{message}}",
      "dismiss": "Dismiss"
    },
    "search": {
      "label": "Find an asset",
      "placeholder": "Find a tag, position or place",
      "none": "No asset matches “{{q}}”."
    },
    "chips": {
      "label": "Places",
      "all": "All",
      "countLabel": "checked",
      "name": "{{place}}, {{checked}} of {{total}} checked"
    },
    "outcome": {
      "DONE": "Done",
      "ISSUE": "Issue",
      "NO_ACCESS": "No access",
      "SKIPPED": "Skipped",
      "label": "{{outcome}}: {{tag}}"
    },
    "row": {
      "more": "More for {{tag}}",
      "skip": "Skip, with a reason",
      "open": "Show its checklist",
      "close": "Hide its checklist",
      "notInVisit": "Not in this visit’s places",
      "earlier": "Checked on {{date}}",
      "outOfOrder": "Out of order",
      "chooseOutcome": "Choose Done, Issue or No access to save."
    },
    "group": {
      "count": "{{checked}} of {{total}} checked",
      "allDone": "All done in {{place}}",
      "allDoneLabel_one": "Mark the {{n}} unchecked asset in {{place}} done",
      "allDoneLabel_other": "Mark the {{n}} unchecked assets in {{place}} done",
      "confirm_one": "Mark {{n}} done",
      "confirm_other": "Mark {{n}} done",
      "cancel": "Cancel",
      "announce_one": "{{n}} asset in {{place}} marked done",
      "announce_other": "{{n}} assets in {{place}} marked done"
    },
    "rest": {
      "show": "Show the rest of the job ({{n}})",
      "hide": "Hide the rest of the job"
    },
    "items": {
      "title": "Checklist",
      "yes": "Done",
      "no": "Not done",
      "readingLabel": "{{label}} ({{unit}})",
      "invalid": "Enter a number: up to 9 digits and 3 decimals.",
      "none": "This asset has no checklist items.",
      "noneRecorded": "Nothing recorded on the checklist.",
      "notChecked": "Not checked on this visit."
    },
    "note": {
      "label": "Note"
    },
    "issue": {
      "label": "What is wrong?",
      "required": "Describe the issue."
    },
    "reason": {
      "label": "Why?",
      "required": "Say why.",
      "common": "Common reasons",
      "tenantAway": "Tenant away",
      "locked": "Locked",
      "unsafe": "Unsafe to reach",
      "noKey": "No key",
      "notNeeded": "Not needed this time",
      "customerAsked": "Customer asked to skip",
      "switchedOff": "Switched off by the customer",
      "removed": "Removed from the site"
    },
    "save": {
      "ISSUE": "Save the issue",
      "NO_ACCESS": "Save: no access",
      "SKIPPED": "Save: skipped",
      "cancel": "Cancel"
    },
    "fault": {
      "open": "Open a fault job",
      "hint": "A new job on this asset, for the office to schedule.",
      "waitForSave": "The fault job can be opened once the issue is saved.",
      "opened": "Fault job {{number}} opened.",
      "link": "Fault job {{number}}",
      "linkShort": "Fault job {{number}}"
    },
    "photos": {
      "afterSave": "Photos can be added once the check is saved."
    }
  }
}
